<template>
  <div>
    <div v-if="showmodal">
      <!-- template for the modal component -->
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container modal-width900">
              <div>
                <!-- <slot name="header"></slot> -->
                <button
                  type="button"
                  data-dismiss="modal"
                  @click="$emit('cancelAction')"
                  class="close d-close"
                >
                  <i class="material-icons">close</i>
                </button>
              </div>

              <div class="container">
                  <div class=" terms-title">
                    <h3>HIPAA Compliance Patient Consent Form</h3>
                  </div>
                  <div class=" terms-content-sec">
                    <p class="mb-3">
                      Our Notice of Privacy Practices explains how we may use or disclose your protected health information (PHI) in accordance with HIPAA (Health Insurance Portability and Accountability Act of 1996) regulations. This notice includes information on your rights as a patient under the law, as well as our commitment to safeguarding your privacy.
                    </p>

                    <p class="mb-3">
                      By consenting, you acknowledge that:
                    </p>
                    <div>
                      <ul>
                       <li> <strong>Use of Information:</strong> Your protected health information may be used or disclosed as needed for treatment, payment, and healthcare operations.</li>
<li><strong>Patient Rights:</strong> You have the right to restrict certain uses and disclosures of your information, although the clinic is not required to agree to such restrictions. However, if an agreement is reached, it will be honored.</li>
<li><strong>Policy Changes:</strong> The practice reserves the right to modify its privacy policy as allowed by law. You will be notified of any changes at your next visit, when you may update your consent.</li>
<li><strong>Revocation of Consent:</strong> You may revoke your consent in writing at any time. This revocation will not apply retroactively to information already disclosed in accordance with prior consent.</li>
                      </ul>
                    </div>
    
                    <p class="mb-3">
                      By checking the box, I consent to the use and disclosure of my protected health information for treatment, payment, and healthcare operations. I understand that this consent may be a condition for receiving treatment and that I may revoke my consent in writing at any time.
                    </p>

                                     </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>


<script>
export default {
  props: ["actionmessage", "showmodal"],
  data() {
    return {};
  },
  methods: {
    closemsg() {},
  },
  create() {},
  // computed: {
  //   getModal() {},
  // },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: block;
  transition: opacity 0.3s ease;
  overflow-y: auto;
}

.modal-wrapper {
  display: block;
  vertical-align: middle;
  margin-top:40px;
  margin-bottom:40px;
}

.modal-container {
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
.terms-title {
  text-align: center;
  margin-top:20px;
  margin-bottom:20px;
  font-weight:600;
  font-size:22px;
}
.terms-content-sec {
  text-align: left;
  padding-left:25px;
  padding-right:25px;
}

.terms-content-sec h2 {
  font-size: 20px;
}

.terms-content-sec h3 {
  font-size: 16px;
}

.terms-content-sec a{
  color:blue;
}
.terms-content-sec h2,
.terms-content-sec h3 {
  font-weight: 400;
}
.p-1 {
  font-weight: 500;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-container.modal-width900 {
  max-width: 900px;
  padding: 20px;
}
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.terms-content-sec ul li {
    padding: 10px 0;
}

.terms-content-sec ul {
    padding: 0 0 0 15px;
}
</style>